import { SpecFilters } from '@deltek/specification-client/core/Widgets/SpecTable'
import { WorkspaceTableItem } from 'models/workspaceTableItem'

export const mapFilterKvpToFiltersModel = (
    rawFilters?: SpecFilters<WorkspaceTableItem>
) => {
    return rawFilters
        ? rawFilters.map((filterKvp: { id: any; value: any }) => ({
              filterValues: Array.isArray(filterKvp.value)
                  ? filterKvp.value
                  : [filterKvp.value],
              itemField:
                  filterKvp.id === 'lastWorkedOn' ? 'name' : filterKvp.id,
          }))
        : []
}

export const remapFilterDataType = (
    mappedFilters: {
        filterValues: string[]
        itemField: string
    }[]
) => {
    mappedFilters.map((filter) => {
        if (filter.itemField === 'dataType') {
            filter.filterValues = filter.filterValues.map((filterValue) => {
                const remappedValue = remapDataType(filterValue)
                return remappedValue
            })
        }
    })

    return mappedFilters
}

const remapDataType = (filterValue: string) => {
    if (filterValue) {
        switch (filterValue.toLowerCase()) {
            case 'product type':
                return 'ProjectNugget'
            case 'family':
                return 'ProjectProductFamily'
            case 'assembly':
                return 'ProjectUniformatClassification'
            default:
                return ''
        }
    } else return ''
}
